<div class="recent_orders">

  <sm-title-bar pageTitle="Coupons" [showBackButton]="true" [headerCustomTemplate]="addButton">
    <ng-template #addButton>
      <button mat-flat-button color="accent" (click)="AddCoupon()">
        
        <mat-icon class="material-icons-round" [inline]="true">add_circle</mat-icon>
        Coupons
      </button>
    </ng-template>
  </sm-title-bar>
  <div *ngIf="isLoading" class="loader">
    <mat-spinner></mat-spinner>
  </div>
  <div class="row" *ngIf="!isLoading">
    <div class="col-sm-4"  *ngFor="let item of couponData;let i=index;">
        <div class="fl_orders"  style="background: white;" >
            <a href="javascript:void(0)" class="admin_category">
                <div class="dropdown icn_plm">
                    <button type="button" class="btn btn-primary dropdown-toggle hvbr" data-toggle="dropdown">
                      <mat-icon>more_horiz</mat-icon>
                        </button>
                    <div class="dropdown-menu mlq">
                        <a class="dropdown-item" href="javascript:void(0)" *ngIf="item.status == 3" (click)="changeStatus(item,1)">Enable</a>
                        <a class="dropdown-item" href="javascript:void(0)" *ngIf="item.status == 1 || item.status == 0" (click)="changeStatus(item,3)">Disable</a>
                        <a class="dropdown-item" href="javascript:void(0)" (click)="deleteCoupon(item,2)">Delete</a>
                    </div>
                </div>
            </a>
            <div class="top_section_order">
                <div class="dis_un" *ngIf="item.status == 1 || item.status == 0">
                  <mat-icon aria-hidden="true" style="color:#34bc27; position: relative; right: -8px;">check</mat-icon>
                  
                </div>
                <div class="dis_un" *ngIf="item.status == 3">
                  <mat-icon aria-hidden="true" style="color:#f39a24;position: relative; right: -8px;  ">error</mat-icon>
                    <!-- <i class="fa fa-times" aria-hidden="true" style=" color: #d30f0f; "></i> -->
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="ads_sec">
                            <div class="hm_icon_ogr">
                                <img src="../../../../assets/images/copo.png">
                            </div>
                        </div>
                        <div class="order_dec">
                            <h3>{{item.coupon_code}}</h3>
                            <p>{{item.service_type}}</p>
                            <p>{{item.start_date.slice(0,10) | date}} - {{item.end_date.slice(0,10) | date}}</p>
                            <p *ngIf="!item.businessHashId || item.businessHashId === 'null'"><span class="cum_text">Coupon Type :</span> For All Merchant</p>
                            <p *ngIf="item.businessHashId"> <span class="cum_text">Coupon Type :</span> Specific Merchant ({{item.businessHashId && item.businessHashId != 'null' ? item.businessHashId : 'No business name added'}})</p>
                            <p><span class="cum_text">Minimum Cart Value :</span> {{item.currency_symbol}}{{item.minimum_cart_value}}</p>
                            <p><span class="cum_text">Discount Type :</span> {{item.discount_type === 1 ? 'Percent' : 'Amount'}}</p>
                            <p><span class="cum_text">Discount Value :</span> {{item.discount_value}}</p>
                            <p></p>
                        </div>
                        <div class="sub3_order">
                            <p style="-webkit-box-orient: vertical;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: normal;">{{item.description}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>


  
  
<!--   
  <mat-paginator class="mt-4" [length]="totalData" [pageSize]="8" (page)="onPageChange($event)">
  </mat-paginator> -->

  <!-- sm-coupons-card -->


</div>

